import React from 'react';

const TabButton = ({ 
  children, 
  isActive, 
  onClick, 
  className = "", 
  style = {} 
}) => {
  const baseClasses = "px-6 py-2 text-sm font-medium rounded-md";
  const activeClasses = "bg-blue-600 text-white";
  const inactiveClasses = "bg-white text-gray-700 border border-custom-blue";
  
  const defaultStyle = { border: '1px solid #004278' };
  const combinedStyle = { ...defaultStyle, ...style };

  return (
    <button
      style={combinedStyle}
      className={`${baseClasses} ${
        isActive ? activeClasses : inactiveClasses
      } ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default TabButton;
